<template>
  <div class="modal-backdrop">
    <div class="modal">
      <div class="content">
        <div class="pull-right">
          <div class="btn-close" @click="close">Close</div>
        </div>
        <h1>{{ title }}</h1>
        <p class="message">
          {{ message }}
        </p>
        <button class="button" @click="close">{{ buttonCaption }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TsOperations',
  data() {
    return {
      title: 'TS Operations',
      message: 'message',
      buttonCaption: 'buttonCaption',
    };
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
@import 'https://use.fontawesome.com/releases/v5.6.3/css/all.css';
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  background: #ffffff;
  border-radius: 4px;
  display: block;
  padding: 25px;
  width: 500px;
  text-align: left;
}

.page .modal .content {
  margin-left: 0;
  text-align: center;
  font-family: 'Open Sans', open-sans, sans-serif;
}

.page .modal .content > h1 {
  margin-top: 0px;
  color: #333c4e;
  font-weight: 300;
}

input {
  float: left;
  background: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: medium none;
  padding-left: 12px;
  width: 290px;
  padding-bottom: 15px;
  margin-bottom: 0;
  height: 51px;
  padding-bottom: 14px;
  padding-top: 15px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  margin: 0 0 20px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

textarea {
  resize: none;
  float: left;
  background: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: medium none;
  padding-left: 12px;
  padding-bottom: 15px;
  margin-bottom: 0;
  padding-bottom: 14px;
  padding-top: 15px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  margin: 0 0 20px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 400px;
  width: 500px;
  overflow: hidden;
}

.message {
  font-size: 16px;
  color: #7e8890;
  line-height: 28px;
  font-weight: 400;
  margin: 0;
  padding: 0;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
  display: block;
  margin-block-start: 0.83em;
  margin-block-end: 0.83em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  font-family: 'Open Sans', open-sans, sans-serif;
  color: #5f697a;
}

button.default {
  color: #464d5d;
  background: #fff;
  border: 1px solid #dee3e9;
  border-radius: 3px 3px 3px 3px;
  width: 99px;
  height: 51px;
  text-transform: uppercase;
  font-weight: 600;
}

.input-group > button {
  min-width: 0;
  width: 99px;
  height: 51px;
  text-transform: uppercase;
  font-weight: 600;
  color: #fff;
  background: #6bbc7c;
  border: 1px solid #5ab36c;
  margin-bottom: 0;
  border-radius: 0 3px 3px 0;
}

.pull-right {
  float: right;
}
.button {
  background: #6cbd7d;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  border-radius: 4px;
  border: 1px solid #4ba75e;
  padding: 16px 20px 15px;
  min-width: 183px;
  -webkit-font-smoothing: antialiased;
  outline: 0;
  margin-top: 40px;
}
</style>
